// composables/usePdfGenerator.js
import { createVNode, render, nextTick } from 'vue';
import Template from '@views/pdfTemplate/Template.vue';
import { useQRCode } from '@vueuse/integrations/useQRCode';
import { useDateFormat } from '@vueuse/core';
import i18n from '../locales/i18n';
const { t } = i18n.global;

export const usePdfGenerator = () => {
    const triggerPdfGeneration = async (result) => {
        const violationDesc = result.cheatings.reduce((acc, item) => {
            acc[item.code] = t(`violations.${item.code}.long`);
            return acc;
        }, {});

        const container = document.createElement('div');
        container.style.display = 'none';
        document.body.appendChild(container);

        const qrcode = useQRCode(`${result.video}`);
        await nextTick();

        const pdfTemplateInstance = createVNode(Template, {
            result,
            qrcode: qrcode.value,
            translation: {
                code: t('profile.code'),
                noData: t('global.noData'),
                desc: t('profile.desc'),
                time: t('profile.time'),
                beforeExam: t('profile.beforeExam'),
                duringExam: t('profile.duringExam'),
                score: t('profile.score'),
                passScore: t('profile.passScore'),
                duration: t('global.duration'),
                start: t('global.start'),
                violations: t('profile.violations'),
                status: t('global.status'),
                sessionName: t('global.sessionName'),
                examID: t('profile.examID'),
                videoScan: t('profile.videoScan', { date: useDateFormat(result.video_valid_date, 'DD.MM.YYYY').value }),
                result: t(`profile.${result.status}`),
                title: t('profile.title'),
                fio: t('profile.fio'),
                videoError: t('profile.videoError'),
                videoDeleted: t('profile.videoDeleted'),
                penalty: t('profile.penalty'),
                isSpoofed: t('profile.isSpoofed'),
                isNotSpoofed: t('profile.isNotSpoofed'),
                faceMatched: t('profile.faceMatched'),
                faceNotMatched: t('profile.faceNotMatched'),
                violationDesc,
            },
            onVnodeMounted: () => {
                const componentInstance = pdfTemplateInstance.component?.exposed;

                componentInstance.generatePdf().then(() => {
                    render(null, container);
                    document.body.removeChild(container);
                });
            },
        });

        render(pdfTemplateInstance, container);
    };

    return { triggerPdfGeneration };
};
